import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import useSendGTMAction from 'features/google-tag-manager/hooks/useSendGTMAction';
import { VirtualPageViewGtmAction } from 'features/google-tag-manager/model/actions/virtual_page_view.gtm-action';
import { sanitizePathname } from 'features/google-tag-manager/utils/sanitize-pathname';

const VirtualPageViewActionListener = () => {
    const sendGTMAction = useSendGTMAction();

    const { pathname } = useLocation();

    const previousPathname = useRef<string | null>(null);

    useEffect((): void => {
        const sanitizedPathname = sanitizePathname(pathname);

        if (sanitizedPathname === previousPathname.current) return;

        sendGTMAction(
            new VirtualPageViewGtmAction({
                pathname: window.location.origin + sanitizedPathname,
            })
        ).then((sent: boolean): void => {
            if (!sent) return;
            previousPathname.current = sanitizedPathname;
        });
    }, [pathname, sendGTMAction]);

    return null;
};

export default VirtualPageViewActionListener;
